






























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  SurveyInfo,
  TsManagerUser,
  TsRateeUser,
  TsUserDto,
  TsUserRole,
  User
} from '@/interfaces'
import { Getter } from 'vuex-class'
import RaterRateeCard from '@/components/360/RaterRateeCard.vue'
import TsService from '@/services/TsService'
import PerformanceManagerCard from '@/components/360/PerformanceManagerCard.vue'
import AppFooter from '@/components/footer/AppFooter.vue'

@Component({
  name: 'RaterRateeGoalPage',
  components: {
    RaterRateeCard,
    PerformanceManagerCard,
    AppFooter
  }
})
export default class RaterRateeGoalPage extends Vue {
  @Prop({ required: true })
  tsSurveyId !: number

  @Prop({ required: true })
  tsRaterRateeId !: number

  @Getter('user/currentUser')
  user!: User

  @Getter('ts/getUsers')
  tsUserInfo!: TsUserDto

  @Getter('user/isAuthenticated')
  isAuthenticated!: boolean

  @Getter('ts/hasRoleRatee')
  hasRoleRatee!: boolean

  @Getter('ts/hasRoleRater')
  hasRoleRater!: boolean

  @Getter('ts/hasRoleManager')
  hasRoleManager!: boolean

  @Getter('survey/getDisplayedBaseSurveyInfo')
  surveyInfo!: SurveyInfo

  ratee: TsRateeUser | null = null
  myPerformanceManager: TsManagerUser | null = null
  rateeMobileNav: boolean = false;
  dataFields: any[] = [
    {
      label: '',
      key: 'smart'
    },
    {
      label: `${this.$t('goals.what_is_goal')}`,
      key: 'goal'
    },
    {
      label: `${this.$t('goals.manager_input')}`,
      key: 'manager_input'
    },
    {
      label: `${this.$t('goals.your_input')}`,
      key: 'your_input'
    },
    {
      label: `${this.$t('goals.success_score')}`,
      key: 'success_score'
    }
  ]
  raterRateeGoals: any[] = [
    {
      smart: 'specific',
      goal: 'Develop Asian FINTEC Network Capabilbity',
      manager_input: "You must learn who the key players are and how they're connected to each other or by departments. Knowing this will allow you to have the right conversation",
      your_input: 'I should learn how to develop the teams capability to network in the Asian contingent of our network',
      success_score: ''
    },
    {
      smart: 'Measurable',
      goal: 'Develop the capability to allow more interaction between the various departments',
      manager_input: "You should look to create diary time specific to these teams so that it's diarised and formal, that way, and it's a process not just a request if they have the time. ",
      your_input: '""',
      success_score: ''
    },
    {
      smart: 'Achievable',
      goal: 'Have at least 3 new departments accepting presentations',
      manager_input: 'Identify who the top 5 teams might be then prioritise who is most receptive to engaging and then try to get them on board as an example to others.',
      your_input: '""',
      success_score: ''
    },
    {
      smart: 'Realistic',
      goal: 'Make sure that our team is able to accommodate the presentations created',
      manager_input: 'The process is time intensive so make sure the pace and the activities can be met by all parties.',
      your_input: '""',
      success_score: ''
    },
    {
      smart: 'Timebound',
      goal: "Complete this by Q3 2021 latest so Q4 can witness it's success in running itself as an established process",
      manager_input: 'You need to have a working model inplace by the end of Q3 so that we can witness the impact the development has created.',
      your_input: '""',
      success_score: ''
    }
  ]

  async created () {
    if (!this.isAuthenticated) {
      await this.$router.push({ name: 'notFound' })
    }

    if (!this.ratee) {
      this.ratee = await TsService.getRateeInfoById(this.tsRaterRateeId)
    }

    await this.uploadMyPerformanceManager()
  }

  scoreFormat (score: string): string {
    return score ? `${score}%` : ''
  }

  goToList (): void {
    this.$router.push({
      name: 'survey.ts.user.ratee',
      params: {
        tsRaterRateeId: this.tsRaterRateeId.toString()
      }
    })
  }

  async toggleRateeMobileNav () {
    this.rateeMobileNav = !this.rateeMobileNav
  }

  async uploadMyPerformanceManager () {
    if (this.hasRoleRatee) {
      const currentRatee = this.tsUserInfo.users.find(user => user.role === TsUserRole.RATEE)
      if (!currentRatee) {
        return
      }

      this.myPerformanceManager = await TsService.getManagerInfo(TsUserRole.RATEE, currentRatee.id)
    } else if (this.hasRoleRater) {
      if (!this.ratee) {
        return
      }

      this.myPerformanceManager = await TsService.getManagerInfo(TsUserRole.RATER, this.ratee.id)
    }
  }
}
